<script>
    import InvitationCountdown from './InvitationCountdown.vue'

    export default {
        props: ['source'],
        components: {InvitationCountdown},
        data() {
            return {
                filterSource: this.source,
                orangopacks: [],
                latitude: null,
                longitude: null,
                pagination: {},
                filters: {
                    sport: "",
                    municipality: "",
                    age: ""
                },
                page: 1,
            }
        },
        computed: {
            activePromotions() {
                return this.orangopacks.filter(i => i.is_active)
            },
            minPromotion() {
                return _.minBy(this.activePromotions, i => i.price)
            },
        },
        mounted() {
            var self = this
            this.$bus.$on("update-filters", this.updateFilters);
            this.latitude = this.getParameterByName("latitude");
            this.longitude = this.getParameterByName("longitude");

            //test per far caricare subito le card
            this.updateFilters();
            //fine test
            let city = this.getParameterByName("city")
            if (! _.isEmpty(city)) {
                this.$bus.$emit('update-search-city', {city})
            } else {
                if (_.isEmpty(this.latitude) && _.isEmpty(this.latitude))
                    this.getLocation()
                else
                    this.updateFilters();
            }

            this.$bus.$on('filter_by_city', function (city) {
                if (!_.isEmpty(city)) {
                    if (_.isObject(city)) {
                        self.filters.municipality = city.name
                    } else if (_.isString(city)) {
                        self.filters.municipality = city
                    }
                } else {
                    self.filters.municipality = "";
                }

                self.updateFilters()
            })
        },
        methods: {
            manualLoad() {
                // this.$nextTick(() => {
                // console.log('nextTick')
                this.fetch();
                // this.$refs.loading.attemptLoad();
                // });
            },
            getPromotionText({municipality, best_promotion, sport}) {
                let lessons = best_promotion.lessons > 1 ? 'lezioni' : 'lezione'
                let people = best_promotion.people > 1 ? 'persone' : 'persona'
                let lessonType = best_promotion.lesson_type == 'group' ? 'collettiva' : 'individuale'
                let mun = municipality ? `- ${municipality}` : ''
                return `${best_promotion.lessons} ${lessons} di ${sport.name} per ${best_promotion.people} ${people} ${mun}`
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        this.returnPosition,
                        this.errorPosition
                    );
                }
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");

                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return "";

                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            returnPosition(position) {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;

                this.updateFilters();
            },
            updateFilters(filters = {}) {
                if (_.isEmpty(filters)) {
                    this.$set(this, "filters", filters);
                }

                this.$set(this, "pagination", {});
                this.$set(this, "page", 1);
                this.$set(this, "orangopacks", []);

                // this.infiniteId += 1;
                this.fetch();
            },
            errorPosition(error) {
                if (_.isEmpty(this.latitude) && _.isEmpty(this.latitude)) {
                    this.latitude = 0;
                    this.longitude = 0;
                    this.fetch();
                } else {
                    this.updateFilters();
                }
            },
            fetch() {
                var self = this;
                axios({
                    method: 'post',
                    url: self.filterSource,
                    data: {
                        filters: self.filters,
                        latitude: self.latitude,
                        longitude: self.longitude,
                        page: self.page
                    }
                }).then(({data}) => {
                    let results = data.results;

                    let temp = self.orangopacks;

                    results.current_page === 1 ? this.$set(this, "orangopacks", results.data) : this.$set(this, "orangopacks", temp.concat(results.data));;

                    this.$bus.$emit("update-sports", data.sports);
                    this.$set(this, "page", results.current_page + 1);
                    this.$set(this, "pagination", _.omit(results, ['data']));
                }).catch(error => {
                    this.$bus.$emit("filtered", null);
                    window.alerts.error("Si è verificato un errore con la tua ricerca");
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/SearchOrangopacksContainer.vue